import * as Yup from "yup";
import { reverseShape } from "Components/shared/helpers/reverse-shape";
import { date, dateRange, validString } from "Components/shared/helpers/validations";

export const RestoreVersionSchema = Yup.object().shape(
  reverseShape({
    code: Yup.mixed().optional(),
    name: Yup.mixed().optional(),
    maxWeight: Yup.mixed().optional(),
    maxDimension: Yup.mixed().optional(),
    insuranceCharges: Yup.mixed().optional(),
    areaName: Yup.mixed().optional(),
    surcharge: Yup.mixed().optional(),
    serviceTypes: Yup.mixed().optional(),
    deliveryTypes: Yup.mixed().optional(),
    locations: Yup.mixed().optional(),
    rates: Yup.mixed().optional(),
    states: Yup.mixed().optional(),
    validFrom: date.required(),
    validTo: date.required().concat(dateRange),
    customerOrgID: Yup.string()
      .when("$isCustomerRequired", {
        is: true,
        then: Yup.string().required(),
      })
      .optional(),
    surchargeType: Yup.string().optional(),
    surchargeFixedAmount: Yup.string().optional(),
    surchargePercentage: Yup.string().optional(),
    surchargeCapAmount: Yup.string().optional(),
    estimatedDeliveryInDay: validString.optional(),
    estimatedTime: validString.optional(),
    cutOffTime: validString.optional(),
  }),
);
